import { DEFAULT_BUTTON_CLASSNAME as N } from "../../Button/constants.js";
import { ButtonVariant as D } from "../../Button/types.js";
import { getModifierClasses as t } from "../../../../utils/preact/className.js";
const S = "adyen-pe-dropdown", C = t(N, [D.SECONDARY], [N]), _ = `${S}__button`, n = `${_}--active`, A = `${_}-collapse-indicator`, c = `${_}--has-selection`, s = `${_}-icon`, R = `${_}-multiselect-counter`, e = `${_}--readonly`, P = `${_}-text`, W = `${_}--valid`, i = `${_}--invalid`, O = `${S}__element`, $ = `${O}--active`, I = `${O}-checkbox`, B = `${O}-checkmark`, U = `${O}-content`, a = `${O}--disabled`, l = `${O}-icon`, r = `${O}--no-option`, T = `${S}__list`, M = `${T}--active`, d = `${S}--multiselect`;
export {
  S as DROPDOWN_BASE_CLASS,
  n as DROPDOWN_BUTTON_ACTIVE_CLASS,
  _ as DROPDOWN_BUTTON_CLASS,
  C as DROPDOWN_BUTTON_CLASSNAME,
  A as DROPDOWN_BUTTON_COLLAPSE_INDICATOR_CLASS,
  c as DROPDOWN_BUTTON_HAS_SELECTION_CLASS,
  s as DROPDOWN_BUTTON_ICON_CLASS,
  i as DROPDOWN_BUTTON_INVALID_CLASS,
  R as DROPDOWN_BUTTON_MULTI_SELECT_COUNTER_CLASS,
  e as DROPDOWN_BUTTON_READONLY_CLASS,
  P as DROPDOWN_BUTTON_TEXT_CLASS,
  W as DROPDOWN_BUTTON_VALID_CLASS,
  $ as DROPDOWN_ELEMENT_ACTIVE_CLASS,
  I as DROPDOWN_ELEMENT_CHECKBOX_CLASS,
  B as DROPDOWN_ELEMENT_CHECKMARK_CLASS,
  O as DROPDOWN_ELEMENT_CLASS,
  U as DROPDOWN_ELEMENT_CONTENT_CLASS,
  a as DROPDOWN_ELEMENT_DISABLED_CLASS,
  l as DROPDOWN_ELEMENT_ICON_CLASS,
  r as DROPDOWN_ELEMENT_NO_OPTION_CLASS,
  M as DROPDOWN_LIST_ACTIVE_CLASS,
  T as DROPDOWN_LIST_CLASS,
  d as DROPDOWN_MULTI_SELECT_CLASS
};
